<template>
    <div v-if="type === 'background-image'" data-magic="image" :style="backgroundStyles">
        <!--<slot v-for="(_, name) in $slots" :name="name"></slot>-->

        <overlay @overlayClicked="logIt">
            <!--<slot name="overlay" slot="overlay"></slot>-->
        </overlay>

        <caption-wrapper @captionClicked="logAt">
            <slot name="caption" slot="caption"></slot>
        </caption-wrapper>
    </div>

    <img v-else :src="src || defaultSrc" class="lw-topbar-logo js-can-edit-element js-can-add-element learnworlds-image learnworlds-image-normal learnworlds-element js-change-image-node" data-node-type="image"/>

</template>

<script>
//    import PageComponentMixin from '../mixins/PageComponentMixin';
    import Overlay from './Overlay.vue';
    import Caption from './Caption.vue';

    export default {
        name: 'Image',

        data () {
            return {
                defaultSrc : window.imagePath + "'images/landing_images/o.school/logo.png" // TODO REFACTOR
            }
        },
        computed: {
            backgroundStyles () {
                return { "background-image": `url("${this.src}")`}
            }
        },
        props: {
            src: {
                type: String,
                default () {
                    return "";
                },
            },
            type: {
                type: String,
                default () {
                    return "background-image"
                }
            }
        },
        components : {
            Overlay,
            "caption-wrapper": Caption
        }

    }
</script>